import Header from "@/components/header";
import { MerchantCustomerNotifierType } from "@/models/club";
import useIsSmall from "@/hooks/useIsSmall";
import SendAutoMessage from "@/modules/profile/sendAutoMessage";
import { useGetCustomerNotifier } from "@/services/autoMessage/hooks/useGetCustomerNotifier";
import { Skeleton } from "@mantine/core";
import classes from "@/modules/profile/sendAutoMessage/autoMessage.module.css";

// Automatic SMS: the ones customers receive, then the one the salon receives. One card style for all.
function AutoMessage() {
  const { data, isLoading } = useGetCustomerNotifier();
  const isSmall = useIsSmall();
  const forCustomers = data?.filter((notifier) => notifier.type !== MerchantCustomerNotifierType.Value2) ?? [];
  const forSalon = data?.filter((notifier) => notifier.type === MerchantCustomerNotifierType.Value2) ?? [];

  return (
    <>
      {isSmall && <Header title="پیامک‌های خودکار" showBack route="/dashboard" />}
      <main className={classes.page} dir="rtl">
        <div className={classes.intro}>
          {!isSmall && <h1>پیامک‌های خودکار</h1>}
          <p>این پیامک‌ها بدون کار اضافه، در لحظه‌ی مناسب فرستاده می‌شوند. هزینه‌ی هر پیامک از اعتبار پیامکی کم می‌شود.</p>
        </div>

        {isLoading ? (
          <div className={classes.grid}>
            {[0, 1, 2].map((i) => <Skeleton key={i} height={190} radius={18} />)}
          </div>
        ) : (
          <>
            {forCustomers.length > 0 && (
              <section className={classes.section}>
                <h2>برای مشتری</h2>
                <div className={classes.grid}>
                  {forCustomers.map((notifier) => <SendAutoMessage config={notifier} key={notifier.type} />)}
                </div>
              </section>
            )}
            {forSalon.length > 0 && (
              <section className={classes.section}>
                <h2>برای خود سالن</h2>
                <div className={classes.grid}>
                  {forSalon.map((notifier) => <SendAutoMessage config={notifier} key={notifier.type} />)}
                </div>
              </section>
            )}
          </>
        )}
      </main>
    </>
  );
}

export default AutoMessage;
